export const GXP_TRAINING_PATH = "/en/services/quality-assurance/regulatory-compliance-training";
export const GXP_TRAINING_TITLE = "Regulatory & Compliance Training";
export const GXP_TRAINING_DESCRIPTION = "Standard or customized GxP and QA training by practitioners: GMP, GDP, GCP, GLP, GVP, ISO 13485, documentation review, auditing and regulatory updates.";
export const GXP_TRAINING_IMAGE = "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/service-images/quality-assurance/gxp-qa-training.jpg";
export const GXP_TRAINING_CARD = {
  title: GXP_TRAINING_TITLE,
  href: GXP_TRAINING_PATH,
  image_url: GXP_TRAINING_IMAGE,
  description: "Standard or customized training delivered by practitioners: GxP foundations and refreshers, quality documentation review, auditing, regulatory updates and the current focus points of regulators.",
};
